module.exports = __webpack_public_path__ + "img/light_blonde.37b5456c.svg";